export default {
  SET_CUSTOM_PAGES(state, payload) {
    state.customPages = payload;
  },
};
